module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('el-card', {
    directives: [{
      name: "loading",
      rawName: "v-loading.body",
      value: (_vm.loading),
      expression: "loading",
      modifiers: {
        "body": true
      }
    }],
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticStyle: {
      "line-height": "36px"
    }
  }, [_vm._v("最新公告")]), _vm._v(" "), _c('i', {
    staticClass: "iconfont icon-new1"
  })]), _vm._v(" "), _vm._l((_vm.tableData), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "item"
    }, [_c('router-link', {
      attrs: {
        "to": ("/dashboard/noticeDetail/" + (item.id))
      }
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('span', {
      staticClass: "fr"
    }, [_vm._v(_vm._s(item.create_time))])], 1)
  }), _vm._v(" "), (_vm.tableData.length == 0) ? _c('div', [_vm._v("还没有公告哦~")]) : _vm._e()], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-465b0748"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/views/dashboard/notice.vue
// module id = 909
// module chunks = 0